/**
 * @generated SignedSource<<d46cc88d376878a68887aa387700a5d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AssigneePickerSharedAssignee$data = {
  readonly __typename: string;
  readonly avatarUrl: string;
  readonly displayName?: string;
  readonly id: string;
  readonly isAgent?: boolean;
  readonly isCopilot?: boolean;
  readonly login: string;
  readonly name: string | null | undefined;
  readonly profileResourcePath: string | null | undefined;
  readonly " $fragmentType": "AssigneePickerSharedAssignee";
};
export type AssigneePickerSharedAssignee$key = {
  readonly " $data"?: AssigneePickerSharedAssignee$data;
  readonly " $fragmentSpreads": FragmentRefs<"AssigneePickerSharedAssignee">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "AssigneePickerSharedAssignee"
};

(node as any).hash = "dad5ce4ed271258c483970f808de8518";

export default node;
